/* @jsxImportSource react */

import type { PropsWithChildren } from 'react';

export type OutlinedCardProps = PropsWithChildren;

export const OutlinedCard = ({ children }: OutlinedCardProps) => (
  <div className="border-color-grey rounded border p-1.5">{children}</div>
);
